module.exports = __webpack_public_path__ + "static/media/YekanBakh-Regular.0484e10a.woff";